import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'confirmation-modal',
  standalone: true,
  template: `
    <div class="modal-header border-bottom-0 pt-6 df-warning-modal">
      <span aria-hidden="true" class="alert-modal-icon fa-exclamation-triangle me-4"></span>
      <h2 class="modal-title">{{ shouldDeploy ? 'Deploy' : 'Undeploy' }} an app</h2>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      </button>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <p>Do you confirm the {{ shouldDeploy ? 'deployment' : 'undeployment' }}
          of the app?<br> The app will be {{ shouldDeploy ? 'deployed to' : 'undeployed from' }} all organizations.
        </p>
      </div>
    </div>
    <div class="modal-footer border-top-0 pb-6">
      <button type="button" class="btn btn-outline-primary me-5" (click)="activeModal.close('CANCEL')">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="activeModal.close('CONFIRM')">Confirm</button>
    </div>
  `
})

export class ConfirmationModalComponent {
  @Input() shouldDeploy!: boolean;

  constructor(public activeModal: NgbActiveModal) { }
}
